import classNames from 'classnames';
import { useAppContext } from '../../../providers/AppProvider';
import { Navbar } from 'react-bootstrap';
import { useBreakpoints } from '../../../providers/BreakpointsProvider';
import NavbarToggleButton from './NavbarToggleButton';
import { Link } from 'react-router-dom';
import logoWhite from "../../../assets/img/icons/logoAlbfaraScris.png"
import logoDark from "../../../assets/img/icons/logoInchisFaraScris.png"
import LogoGriEnergoplast from "../../../assets/img/energoplastGri30.png"

const NavbarBrand = () => {
  const {
    config: { theme, navbarTopShape, navbarPosition }
  } = useAppContext();
  const { breakpoints } = useBreakpoints();


  // Choose the logo based on the theme
  const logoSrc = theme === 'dark' ? LogoGriEnergoplast: logoDark ;


  return (
    <>
      <div className="navbar-logo">
        {breakpoints.down('lg') && <NavbarToggleButton />}
        <Navbar.Brand
          as={Link}
          to="/"
          className={classNames({
            'me-1 me-sm-3':
              navbarTopShape === 'slim' || navbarPosition === 'horizontal'
          })}
        >
          {navbarTopShape === 'slim' ? (
            <>
              energoplast <span className="text-1000 d-none d-sm-inline">slim</span>
            </>
          ) : (
            <div className="d-flex align-items-center">
              <img src={logoSrc} alt="phoenix" width={100} />
              {/* <p className="logo-text ms-2 d-none d-sm-block">energoplast</p> */}
            </div>
          )}
        </Navbar.Brand>
      </div>
    </>
  );
};

export default NavbarBrand;
